(function () {
  function initProductModalNavigation(modal) {
    if (modal.dataset.navInit === 'true') return;
    modal.dataset.navInit = 'true';

    const content = modal.querySelector('.product-media-modal__content');
    const prevBtn = modal.querySelector('.media-prev');
    const nextBtn = modal.querySelector('.media-next');
    if (!content || !prevBtn || !nextBtn) return;

    const mediaItems = [...content.querySelectorAll('.global-media-settings')];
    if (!mediaItems.length) return;

    let currentIndex = mediaItems.findIndex(item =>
      item.classList.contains('active')
    );
    if (currentIndex === -1) currentIndex = 0;

    function updateVisibility() {
      mediaItems.forEach((item, index) => {
        item.style.display = index === currentIndex ? '' : 'none';
        item.classList.toggle('active', index === currentIndex);
      });

      prevBtn.style.display = currentIndex === 0 ? 'none' : 'flex';
      nextBtn.style.display =
        currentIndex === mediaItems.length - 1 ? 'none' : 'flex';
    }

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateVisibility();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (currentIndex < mediaItems.length - 1) {
        currentIndex++;
        updateVisibility();
      }
    });

    updateVisibility();
  }

  const observer = new MutationObserver(() => {
    const modal = document.querySelector(
      'product-modal.product-media-modal[open]'
    );
    if (modal) {
      initProductModalNavigation(modal);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });
})();